import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AppMain, Navbar, TagsView } from './components';
import AppSidebar from './components/Sidebar/index.vue';
import ResizeMixin from './mixin/ResizeHandler';
import { mapState } from 'vuex';
var platformEnv = process.env.VUE_APP_PLATFORM;
export default {
  name: 'LayoutIndex',
  components: {
    AppMain: AppMain,
    Navbar: Navbar,
    AppSidebar: AppSidebar,
    TagsView: TagsView
  },
  mixins: [ResizeMixin],
  data: function data() {
    return {
      platformEnv: platformEnv
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    // 勿用名 sidebar：与侧栏组件/标签解析冲突时会导致子组件不渲染（DOM 仅 <!---->）
    appSidebar: function appSidebar(state) {
      return state.app.sidebar;
    },
    device: function device(state) {
      return state.app.device;
    },
    full: function full(state) {
      return state.app.full;
    },
    needTagsView: function needTagsView(state) {
      return state.settings.tagsView;
    },
    fixedHeader: function fixedHeader(state) {
      return state.settings.fixedHeader;
    }
  })), {}, {
    classObj: function classObj() {
      return {
        hideSidebar: !this.appSidebar.opened,
        openSidebar: this.appSidebar.opened,
        withoutAnimation: this.appSidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    }
  }),
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      });
    }
  }
};